import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import SamplePage from "./pages/SamplePage";
import MainLayout from "./MainLayout";
import ProjectsPage from "./pages/ProjectsPage";
import ClientsPage from "./pages/ClientsPage";
import IssuesPage from "./pages/IssuesPage";
import CxProjectsPage from "./pages/CxProjectsPage";
import CxEquipmentPage from "./pages/CxEquipmentPage";
import CxChecklistPage from "./pages/CxChecklistPage";
import CxSystemsPage from "./pages/CxSystemsPage";
import FileUploadPageCustom from "./pages/FileUploadPageCustom";
import LogsPage from "./pages/LogsPage";
import { ProjectContextProvider } from "./context/ProjectContextProvider";
import ProtectedRoute from "./ProtectedRoute";
import PowerUserRoute from "./PowerUserRoute";
import { useAuth } from './AuthProvider'

function App() {
    // const { keycloak } = useKeycloak();
    const { keycloak, authenticated } = useAuth()


    // if (!keycloak.authenticated) return <div>Loading...</div>;

    if (!authenticated) {
        return <button onClick={() => keycloak.login()}>Log in</button>
    }

    return (
    <>
        <ProjectContextProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                        <Route index element={<ProtectedRoute><CxProjectsPage /></ProtectedRoute>}/>
                        <Route path="cxprojects" element={<ProtectedRoute><CxProjectsPage /></ProtectedRoute>}/>
                        <Route path="clients" element={<ProtectedRoute><ClientsPage /></ProtectedRoute>}/>
                        <Route path="cxequipment" element={<ProtectedRoute><CxEquipmentPage /></ProtectedRoute>}/>
                        <Route path="cxchecklist" element={<ProtectedRoute><CxChecklistPage /></ProtectedRoute>}/>
                        <Route path="cxsystems" element={<ProtectedRoute><CxSystemsPage /></ProtectedRoute>}/>
                        <Route path="issues" element={<ProtectedRoute><IssuesPage /></ProtectedRoute>}/>
                        <Route path="sample" element={<ProtectedRoute><SamplePage /></ProtectedRoute>}/>
                        <Route path="upload" element={<ProtectedRoute><FileUploadPageCustom /></ProtectedRoute>}/>
                        <Route path="logs" element={<ProtectedRoute><LogsPage /></ProtectedRoute>}/>
                    </Route>
                </Routes>
            </Router>
        </ProjectContextProvider>
    </>
    );
}

export default App;
